import { httpsCallable } from 'firebase/functions'
import { functions } from '@/firebase'

export interface StoreAccountDirectory {
  activeIds: string[]
  inactiveIds: string[]
  total: number
  active: number
  inactive: number
  schoolStudentCount: number
}

export async function getStoreAccountDirectory(storeCode: string, includeInactive: boolean) {
  const callable = httpsCallable<
    { storeCode: string; includeInactive: boolean },
    StoreAccountDirectory
  >(functions, 'getStoreAccountDirectory')
  return (await callable({ storeCode, includeInactive })).data
}
